module.exports = __webpack_public_path__ + "static/img/logo_all.2fdcc05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_all.png
// module id = jjxP
// module chunks = 110